// src/lib/avatar.js — upload de avatar (porte fiel do uploadAvatar do monólito).
// Resize no navegador (máx 1024px, JPEG .85) + bucket `avatars/<userId>/avatar.jpg`.
// Exposto como window.uploadAvatar para casar com o markup verbatim (onchange="uploadAvatar(this)").
import { sb } from '../api/supabaseClient.js';
import { guardTrial } from './trialGate.js';
import { tenant } from '../context/tenantContext.js';
import { showToast } from './toast.js';

function _resize(file) {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const MAX = 1024;
      let w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
      if (w > MAX || h > MAX) { const r = Math.min(MAX / w, MAX / h); w = Math.round(w * r); h = Math.round(h * r); }
      const cv = document.createElement('canvas'); cv.width = w; cv.height = h;
      const ctx = cv.getContext('2d');
      if (!ctx) { URL.revokeObjectURL(url); resolve(file); return; }
      ctx.drawImage(img, 0, 0, w, h);
      URL.revokeObjectURL(url);
      cv.toBlob((b) => resolve(b || file), 'image/jpeg', 0.85);
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
    img.src = url;
  });
}

function _refreshAvatars(url) {
  document.querySelectorAll('.cli-mob-perfil-av, .fmob-perfil-av, .sup-perfil-av, .sb-user-avatar, .ges-av, .adm-av, .fn-av, .sn-av, .clm-av').forEach((el) => {
    el.innerHTML = `<img src="${url}" alt="" style="width:100%;height:100%;object-fit:cover">`;
  });
  try { window.dispatchEvent(new CustomEvent('avatar:updated', { detail: { url } })); } catch (_) {}
}

export async function uploadAvatar(input) {
  if (guardTrial()) return;

  const file = input?.files?.[0];
  if (!file) return;
  if (!file.type || !file.type.startsWith('image/')) { showToast('Selecione uma imagem (JPG, PNG ou WEBP).', 'error'); return; }
  if (file.size > 25 * 1024 * 1024) { showToast('Imagem muito grande. Máx 25MB.', 'error'); return; }
  showToast('Enviando foto...');
  try {
    const blob = await _resize(file);
    const path = `${tenant.user.id}/avatar.jpg`;
    const { error: upErr } = await sb.storage.from('avatars').upload(path, blob, { upsert: true, contentType: 'image/jpeg' });
    if (upErr) throw upErr;
    const { data: urlData } = sb.storage.from('avatars').getPublicUrl(path);
    const publicUrl = urlData.publicUrl + `?t=${Date.now()}`;
    const { error: dbErr } = await sb.from('users_profile').update({ avatar_url: publicUrl }).eq('id', tenant.user.id);
    if (dbErr) throw dbErr;
    try { if (tenant.profile) tenant.profile.avatar_url = publicUrl; } catch (_) {}
    if (tenant.profile?.tipo_usuario === 'funcionario') {
      try { await sb.from('funcionarios').update({ foto_url: publicUrl }).eq('user_id', tenant.user.id); } catch (_) {}
    }
    _refreshAvatars(publicUrl);
    showToast('Foto atualizada!');
  } catch (err) {
    showToast('Erro ao enviar foto: ' + (err.message || err), 'error');
  }
  input.value = '';
}

if (typeof window !== 'undefined') window.uploadAvatar = uploadAvatar;
